import { TFunction } from "react-i18next";
import { ProductApi, ProductStateApi } from "../../../../../../../services/Api/Organization/types";

export const getStateForProduct = (item: ProductApi | undefined, productStates: ProductStateApi[]) => {
	if (!item) return;
	const state = productStates.find((s) => Number(s.product_id) === Number(item.id));
	if (state) return state.product_state;
	return (
		item.state || {
			in_stock_amount: 0,
			available_amount: 0,
			commited_amount: 0,
			incoming_amount: 0,
		}
	);
};

export const drawProductState = (item: ProductApi | undefined, productStates: ProductStateApi[], t: TFunction) => {
	const state = getStateForProduct(item, productStates);
	if (state)
		return `${t("common.word.in_stock")}: ${state.in_stock_amount} | 
                ${t("common.word.committed_amount").toLowerCase()}: ${state.commited_amount} |
                ${t("common.word.incoming_amount").toLowerCase()}: ${state.incoming_amount}
        `;
};

export const getInStockAmountBadgeColor = (item: ProductApi, productStates: ProductStateApi[]) => {
	const productState = getStateForProduct(item, productStates);
	if (productState && productState.in_stock_amount > 0) return "success";
	return "danger";
};
